import { Component, OnInit, ViewChild, AfterViewInit, ViewContainerRef } from '@angular/core';
import { HomeAuctionDetailService } from '../../services/home-auction-detail.service';
import { Auction } from '../../models/auction';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import { BusAuctionFilterService } from '../../services/bus-auction-filter.service';
import { environment } from '../../../../../environments/environment';
import { DistributorAuction } from '../../models/distributor-auction';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv'
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import {HttpClient} from '@angular/common/http';
import { ModalMailSenderComponent } from './modal-mail-sender/modal-mail-sender.component';
import { ModalHistoryChangeComponent } from './modal-history-change/modal-history-change.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { HomeMainModalDetailMemberComponent } from '../home-main-modal-detail-member/home-main-modal-detail-member.component';
import {TokenStorage} from '../../../../storages/token.storage';
import {ModalSendAdjustmentComponent} from './modal-send-adjustment/modal-send-adjustment.component';
import { ModalMnnComponent } from './modal-mnn/modal-mnn.component';

const apiServer = environment.apiServer;
declare var $: any;

@Component({
  selector: 'app-home-main-modal-detail',
  templateUrl: './home-main-modal-detail.component.html',
  styleUrls: ['./home-main-modal-detail.component.scss'],
})

export class HomeMainModalDetailComponent implements OnInit, AfterViewInit {
  popupHtmlContent: any = { value: "" }

  columnsAuction: any[];

  auction: Auction = new Auction();
  dtOptionsAuctions: DataTables.Settings = {};
  dataSetAuction: any;
  http: HttpClient;
  mailPopover = new Array<string>();
  detailDistributionFirst: string;
  detailDistributionSecond: string;
  spinner: NgxSpinnerService;
  bus: BusAuctionFilterService;
  _type:number;
  token:TokenStorage;
  isChiefRole;
  isContainCd = false; 
  isContainFm = false;  
  rejected = false;
  isContainSai = false;

  hideOutFromDevelopFilter = false;

  pageSize = 100;  
  currentpage = 1;
  first;

  constructor(private service: HomeAuctionDetailService, 
    private _bus: BusAuctionFilterService, 
    private toastr: ToastsManager,
    private vcr: ViewContainerRef, 
    private _http: HttpClient, 
    private _spinner: NgxSpinnerService, 
    private _token: TokenStorage) {

    this.bus = _bus;
    this.bus.currentAuction = this.auction;
    this.toastr.setRootViewContainerRef(vcr);
    this.http = _http;
    this.spinner = _spinner;
    this.token = _token;
  }
  
  defaultInit(){
    this.updateStateMailIcon();
    this.enableButtonParticiant(false);
    this._type = null;

    this.isContainCd = false; 
    this.isContainFm = false;
    this.rejected = false;

    this.isChiefRole = this.token.isChiefRole();

   }

  ngOnInit() {

    $('[data-toggle="modal"]').popover();
    this.columnsAuction = [
      { field: 'numberOfRow', header: '№', width: 40, title: 'Порядковый номер строки'},
      { field: 'aucDetailAgreementStatus', header: 'Статус', width: 104, title: 'Статус' },
      { field: 'mnnName', header: 'МНН', width: 145, title: 'МНН, как прописано в строках аукциона ИАС', min_width: 125 },
      { field: 'universalName', header: 'ТН ИАС', width: 145, title: 'Торговое наименование, как прописано в строках аукциона ИАС' },
      { field: 'soloName', header: 'ТН СолоФарм', width: 150, title: 'Наименование Солофарм'},
      { field: 'actualPosition', header: 'АП', width: 50, title: 'Актуальная позиция'},
      { field: 'amountSolo', header: 'Кол-во', width: 100, title: 'Кол-во в упаковках СолоФарм'},
      { field: 'startMaxPrice', header: 'НМЦ', width: 70, title: 'Начальная максимальная цена'},
      { field: 'standartSoloPrice', header: 'ПЛ', width: 70, title: 'Стандартная цена прайс-листа СолоФарм'},
      { field: 'specialPrice', header: 'СП', width: 70, title: 'Специальная цена прайс-листа СолоФарм'},
      { field: 'registerCost', header: 'ГР', width: 70, title: 'Цена госреестра в руб. без НДС'},
      { field: 'recommendedPrice', header: 'РЦ', width: 70, title: 'Рекомендованная Цена'},
      { field: 'recommendedPriceType', header: 'Тип РЦ', width: 100, title: 'Тип рекомендованной цены'},
      { field: 'commertialPrice', header: 'КП 1', width: 70, title: 'Цена коммерческого предложения 1'},
      { field: 'commertialPrice2', header: 'КП 2', width: 70, title: 'Цена коммерческого предложения 2'},
      { field: 'kpsaI1', header: 'КП1 SAI', width: 100, title: 'КП1 SAI'},
      { field: 'kpsaI2', header: 'КП2 SAI', width: 100, title: 'КП2 SAI'},
      { field: 'margin1', header: 'Марж-ть 1, %', width: 120, title: 'Марж-ть 1, %'},
      { field: 'margin2', header: 'Марж-ть 2, %', width: 120, title: 'Марж-ть 2, %'},
      { field: 'contractPrice', header: 'ЦК', width: 60, title: 'Цена контракта'},
      // { field: 'invoicePrice', header: 'ЦН', width: 60, title: 'Цена накладной', min_width: 50 },
      // { field: 'winnerPrice', header: 'ИАС', width: 60, title: 'Цена победителя по ИАС', min_width: 50 },
      { field: 'sumNmc', header: 'Ст НМЦ', width: 90, title: 'Стоимость по НМЦ'},
      { field: 'sumPl', header: 'Ст ПЛ', width: 90, title: 'Стоимость по ПЛ'},
      { field: 'weightPositionInPercent', header: '%', width: 50, title: '% от стоимости лота'},
      { field: 'isWinner', header: 'В...', width: 50, title: 'Гротекс выиграл'},
      { field: 'manufacturer', header: 'Производитель', width: 140, title: 'Производитель по ИАС'},
      { field: 'comment', header: 'Коммент.', width: 100, title: 'Комментарий'}
    ];
    const that = this;
    //
    this.dtOptionsAuctions = {
      pagingType: 'full_numbers',
      pageLength: 100,
      autoWidth: true,
      dom: 'tip',
      info: false,
      // scrollY: '730px',
    };

    this.first = (this.currentpage-1)* this.pageSize;
    this.bus.currentAuctionNumber$.subscribe(auctionNumber => {
      this.spinner.show();
      if (auctionNumber != null && auctionNumber !== '') {
        that.service.get(auctionNumber).subscribe(auc => {
          if (auc != null) {
            setTimeout(() => { $('[data-toggle="popover"]').popover()}, 1000);
            this.bus.currentAuction = auc;
            this.dataSetAuction = auc.drugs;
            this.defaultInit();
            setTimeout(function() { $('#tableAuction').dataTable(); }, 4000);
            const disAuc = new DistributorAuction();
            disAuc.distributerLogistic = auc.distributerLogistic;

            disAuc.distributerParticipant = auc.distributerParticipant;
            disAuc.distributerParticipant2 = auc.distributerParticipant2;
            disAuc.distributerParticipantSAI1 = auc.distributerParticipantSAI1;
            disAuc.distributerParticipantSAI2 = auc.distributerParticipantSAI2;

            disAuc.distributerParticipantName = auc.distributerParticipantName;
            disAuc.distributerParticipant2Name = auc.distributerParticipant2Name;
            disAuc.distributerParticipantSAI1Name = auc.distributerParticipantSAI1Name;
            disAuc.distributerParticipantSAI2Name = auc.distributerParticipantSAI2Name;

            disAuc.distributerWinner = auc.distributerWinner;
            disAuc.distributerWinnerName = auc.distributerWinner;
            
            this.bus.changeDistributerAuction(disAuc);
            this.spinner.hide();
            this.getDetailDistribution();
          }
        });
      }
    });

    this.bus.currentDistributerAuction$.subscribe(distributerAuction => {

      
      this.bus.currentAuction.distributerParticipant = distributerAuction.distributerParticipant;
      this.bus.currentAuction.distributerParticipantName = distributerAuction.distributerParticipantName;
      
      this.bus.currentAuction.distributerParticipant2 = distributerAuction.distributerParticipant2;
      this.bus.currentAuction.distributerParticipant2Name = distributerAuction.distributerParticipant2Name;
      
      this.bus.currentAuction.distributerParticipantSAI1 = distributerAuction.distributerParticipantSAI1;
      this.bus.currentAuction.distributerParticipantSAI1Name = distributerAuction.distributerParticipantSAI1Name;

      this.bus.currentAuction.distributerParticipantSAI2 = distributerAuction.distributerParticipantSAI2;
      this.bus.currentAuction.distributerParticipantSAI2Name = distributerAuction.distributerParticipantSAI2Name;
      
      this.bus.currentAuction.distributerWinner = distributerAuction.distributerWinner;
      this.bus.currentAuction.distributerWinnerName = distributerAuction.distributerWinnerName;
      
      if(this._type != null){
        this.spinner.show();
        this.changeDetail();
        this.getDetailDistribution();
        this.updateDrugs(this._type);
      }

    });

    this.bus.currentContractBaseAuction$.subscribe(contractorAuction => {
      this.bus.currentAuction.primaryContract = contractorAuction.contractName;
    });
  }

  onExport(): void {

    if (this.auction.drugs != null) {
      const optionsCvs = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalseparator: '.',
        showLabels: true,
        showTitle: true,
        useBom: true,
        noDownload: false,
        headers: [
          'Код аукциона',
          'Порядковый номер строки',
          'Группа СолоФарм. Загружается из ХД',
          'Код СолоФарм',
          'Наименование СФ: Наименование Солофарм',
          'МНН, как прописано в строках аукциона ИАС',
          'Торговое наименование, как прописано в строках аукциона ИАС',
          'Кол-во в упаковках СолоФарм',
          'Начальная максимальная цена',
          'Стандартная цена прайс-листа СолоФарм',
          'Минимальная цена прайс-листа СолоФарм',
          'Цена коммерческого предложения',
          'Цена контракта',
          'Цена накладной',
          'Цена победителя по ИАС',
          'Стоимость по НМЦ',
          'Стоимость по ПЛ',
          '% от стоимости лота',
          'Спецификация по ИАС',
          'Производитель по ИАС',
          'Комментарий'
        ]
      };

      const n = new Angular5Csv(this.auction.drugs, 'Drugs', optionsCvs);
    }



  }

  mailHistory() {
    this.mailPopover[0] = this.mailPopover[1] = this.mailPopover[2] = "Загрузка истории...";
    if (this.bus.currentAuction.code != null) {
      this.http.get<Array<string>>(apiServer + "/commercial_offer/history/" + this.bus.currentAuction.code)
        .subscribe(resp => {
          this.mailPopover = resp;
        });
    }
  }

    getDetailDistribution() {
      this.detailDistributionFirst = this.detailDistributionSecond = "Загрузка алгоритма...";
      if (this.bus.currentAuction.distributerParticipantName != null && this.bus.currentAuction.distributerParticipantName.length > 0) {
        this.http.get<any>(apiServer + "/auction/detailDistribution/" + this.bus.currentAuction.distributerParticipantName)
          .subscribe(resp => {
            if(resp != null && resp.mainInfo){
              this.detailDistributionFirst = resp.mainInfo;
            }else{
              this.detailDistributionFirst = "Ошибка";
            }
          });
      }
      if (this.bus.currentAuction.distributerParticipant2Name != null && this.bus.currentAuction.distributerParticipant2Name.length > 0) {
        this.http.get<any>(apiServer + "/auction/detailDistribution/" + this.bus.currentAuction.distributerParticipant2Name)
          .subscribe(resp => {
            if(resp != null && resp.mainInfo){
              this.detailDistributionSecond = resp.mainInfo;
            }else{
              this.detailDistributionSecond = "Ошибка";
            }
          });
      }
    }
  

    @ViewChild(ModalMailSenderComponent)
    m: ModalMailSenderComponent;

    mailToCommercialOffer(type: number){
      if (this.m != undefined) {
        this.m.mailToCommercialOffer(this.bus.currentAuction.code, + type, this.popupHtmlContent)
      }
    }

    @ViewChild(ModalHistoryChangeComponent)
    modalHistory: ModalHistoryChangeComponent

    historyChange(){
      if (this.modalHistory != undefined) {
        this.modalHistory.loadHistoryChange(this.bus.currentAuction.code);
      }
    }

    @ViewChild(ModalMnnComponent)
    modalMnn: ModalMnnComponent

    mnnInfo(){
      if (this.modalMnn != undefined) {
        this.modalMnn.loadMnn(this.bus.currentAuction.code);
      }
    }

  onSave() {
    this.spinner.show();
    $( "button:disabled" ).attr("title", "");
    this.service.putAuction(this.bus.currentAuction).subscribe(result => {

      this.bus.changeAuctionNumber(this.bus.currentAuction.code);

      this.bus.reloadAuction();

      if (!this.isContainFm && !this.isContainCd)
      if(this.rejected) {
        this.SendAdjustmentMail("rejected");
      } else {
        this.SendAdjustmentMail("confirmed");
      }  
 
    });
    this.enableButtonParticiant(false);
    this.updateStateMailIcon();
  }


  onSaveAndExit(exit:boolean) {
    this.spinner.show();
    $( "button:disabled" ).attr("title", "");
    this.service.putAuction(this.bus.currentAuction).subscribe(result => {
      this.spinner.hide();
      this.bus.reloadAuction();

      if (!this.isContainFm && !this.isContainCd)
      if(this.rejected) {
        this.SendAdjustmentMail("rejected");
      } else {
        this.SendAdjustmentMail("confirmed");
      }  
    });
    this.updateStateMailIcon();
    this.enableButtonParticiant(false);
    $('#modalAuctionDetail').modal('toggle');
  }

  private updateStateMailIcon() {
      this.mailHistory();

      var isNeedAdjustment;
      const st = this.bus.currentAuction.aucAgreementStatus;
      if(st == "Не требует согласования" || st == "Согласовано"){
        isNeedAdjustment = false;
      }else{
        isNeedAdjustment = true;
      }



      if ((this.bus.currentAuction.distributerParticipantName != "" && this.bus.currentAuction.distributerParticipantName != undefined  && !isNeedAdjustment && !this.rejected)||
      (this.bus.currentAuction.distributerParticipant != "" && this.bus.currentAuction.distributerParticipant != undefined) && !isNeedAdjustment && !this.rejected) {
        document.getElementById("buttonMailSender1").classList.remove('text-danger');
        document.getElementById("buttonMailSender1").classList.add('text-success');
        $('#buttonMailSender1').attr("disabled", false);
      }else{
        document.getElementById("buttonMailSender1").classList.remove('text-success');
        document.getElementById("buttonMailSender1").classList.add('text-danger');
        $('#buttonMailSender1').attr("disabled", true);
      }

      if ((this.bus.currentAuction.distributerParticipant2Name != "" && this.bus.currentAuction.distributerParticipant2Name != undefined  && !isNeedAdjustment && !this.rejected)||
      (this.bus.currentAuction.distributerParticipant2 != "" && this.bus.currentAuction.distributerParticipant2 != undefined) && !isNeedAdjustment && !this.rejected) {
        document.getElementById("buttonMailSender2").classList.remove('text-danger');
        document.getElementById("buttonMailSender2").classList.add('text-success');
        $('#buttonMailSender2').attr("disabled", false);
      }else{
        document.getElementById("buttonMailSender2").classList.remove('text-success');
        document.getElementById("buttonMailSender2").classList.add('text-danger');
        $('#buttonMailSender2').attr("disabled", true);
      }

  }

  enableButtonParticiant(disabled){
    // $('#buttonParticiant1').attr("disabled", disabled);
    // $('#buttonParticiant2').attr("disabled", disabled);
    //$('#buttonParticiant3').attr("disabled", disabled);
    //title="текст"
  }

  hideOutFromDevelop(isHide: boolean){
    if(this.hideOutFromDevelopFilter != isHide){
      this.hideOutFromDevelopFilter = isHide
    }
  }

  onSelectedStatus(status) {
    if (this.bus.currentAuction != null) {
      this.bus.currentAuction.status = status;
      this.changeDetail();
    }
  }

  onSelectedStatusST(statusST) {    
    if (this.bus.currentAuction != null) {
      this.bus.currentAuction.statusST = statusST;      
      this.changeDetail();
    }
  }

  onSetCurrentRow(drug) {    
    this.bus.currentAuction.drugs.forEach((item, index) => {
      item.current = item === drug;
    });    
    this.changeDetail();
  }

  isShowSaiStatus(){
    if(this.isChiefRole || (this.bus.currentAuction.status != null &&
      this.bus.currentAuction.status != undefined &&
         this.bus.currentAuction.status.toLocaleLowerCase().indexOf("sai") >= 0)){
      return true;
    }else{
      return false;
    }
  }

  isShowSaiStatusInvert(){
    if(this.isChiefRole){
      return true;
    }else{
      if (this.bus.currentAuction.status != null && this.bus.currentAuction.status != undefined &&
           this.bus.currentAuction.status.toLocaleLowerCase().indexOf("sai") >= 0){
            return false;
           }
      return true;
    }
  }

  @ViewChild(HomeMainModalDetailMemberComponent)
  DetailMember: HomeMainModalDetailMemberComponent;

  onSetDistributor(type: number, autogenerate: boolean) {
    this._type = type;
    if (autogenerate) {
      if (type == 1 || type == 2) {
        this.spinner.show();
        this.http.get<Array<string>>(apiServer + "/manufacturer/" + this.bus.currentAuction.code + "/" + type)
          .subscribe(resp => {
            if (resp != null)

              var modelDistributorAuction = new DistributorAuction();
            switch (type) {
              case 1:
                this.bus.currentAuction.distributerParticipant = resp['distrID'];
                this.bus.currentAuction.distributerParticipantName = resp['participant'];

                modelDistributorAuction.distributerParticipant = resp['distrID'];
                modelDistributorAuction.distributerParticipantName = resp['participant'];
                this.bus.changeDistributerAuction(modelDistributorAuction);
              break;
              case 2:
                this.bus.currentAuction.distributerParticipant2 = resp['distrID'];
                this.bus.currentAuction.distributerParticipant2Name = resp['participant'];

                var modelDistributorAuction = new DistributorAuction();
                modelDistributorAuction.distributerParticipant2 = resp['distrID'];
                modelDistributorAuction.distributerParticipant2Name = resp['participant'];
                this.bus.changeDistributerAuction(modelDistributorAuction);
                break;
              default:
                break;
            }
            this.updateDrugs(type);
            this.getDetailDistribution();
            this.changeDetail();
          });

      }
    }
    if (type == 3) {
      this.DetailMember.onFieldChange();
    }
    
    this.bus.currentDistributorType.type = type;
  }

  // Присвоение статуса строкам
  updateDrugsAfterChangeСp(alterRow = undefined) {
    
    this.spinner.show();
    
    this.http.put<any>(apiServer + "/auction/detail/temp/3", this.bus.currentAuction).subscribe(result => {
      setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);
      for (let indexA = 0; indexA < this.bus.currentAuction.drugs.length; indexA++) {
        if (this.bus.currentAuction.drugs[indexA].numberOfRow + this.bus.currentAuction.drugs[indexA].soloName == alterRow) {
          for (let indexB = 0; indexB < result['drugs'].length; indexB++) {
            if (result['drugs'][indexB].numberOfRow + result['drugs'][indexB].soloName == alterRow) {
              this.bus.currentAuction.drugs[indexA] = result['drugs'][indexB];
              break;
            }
          }
          this.changeDetail();
        }
      }
      this.spinner.hide();
    });

 }


  updateDrugs(type: number, alterRow = undefined) {
    
     this.spinner.show();

    if(type != null){
      if(type == 4){
        this.spinner.hide()
        return
      }
      this.http.put<any>(apiServer + "/auction/detail/temp/" + type, this.bus.currentAuction).subscribe(result => {
       setTimeout(() => { $('[data-toggle="popover"]').popover()}, 1000);
      this.bus.currentAuction.drugs = result['drugs'];
        this.spinner.hide();
      });
    }
    else {
      if (alterRow != undefined) { // Выбор альтернативной номенклатуры numberOfRow

        this.http.put<any>(apiServer + "/auction/detail/temp/1", this.bus.currentAuction).subscribe(result => {
          for (let indexA = 0; indexA < this.bus.currentAuction.drugs.length; indexA++) {
            if (this.bus.currentAuction.drugs[indexA].numberOfRow + this.bus.currentAuction.drugs[indexA].soloName == alterRow) {
              for (let indexB = 0; indexB < result['drugs'].length; indexB++) {
                if (result['drugs'][indexB].numberOfRow + result['drugs'][indexB].soloName == alterRow) {
                  this.bus.currentAuction.drugs[indexA] = result['drugs'][indexB];
                  break;
                }
              }
            }
          }

          this.spinner.hide();

          this.http.put<any>(apiServer + "/auction/detail/temp/2", this.bus.currentAuction).subscribe(result => {
            setTimeout(() => { $('[data-toggle="popover"]').popover() }, 1000);
            for (let indexA = 0; indexA < this.bus.currentAuction.drugs.length; indexA++) {
              if (this.bus.currentAuction.drugs[indexA].soloName == alterRow) {
                for (let indexB = 0; indexB < result['drugs'].length; indexB++) {
                  if (result['drugs'][indexB].numberOfRow + result['drugs'][indexB].soloName == alterRow) {
                    this.bus.currentAuction.drugs[indexA] = result['drugs'][indexB];
                    break;
                  }
                }
              }
            }
          });

        });

      }else{
        this.http.put<any>(apiServer + "/auction/detail/temp/1", this.bus.currentAuction).subscribe(result => {
         this.bus.currentAuction.drugs = result['drugs'];
         this.spinner.hide();

  
           this.http.put<any>(apiServer + "/auction/detail/temp/2", this.bus.currentAuction).subscribe(result => {
           setTimeout(() => { $('[data-toggle="popover"]').popover()}, 1000);
           this.bus.currentAuction.drugs = result['drugs'];

           });
         });
      }
    }
  }

  changeDetail(){
    document.getElementById("buttonMailSender1").classList.remove('text-success');
    document.getElementById("buttonMailSender1").classList.add('text-danger');
    $('#buttonMailSender1').attr("disabled", true);
    document.getElementById("buttonMailSender2").classList.remove('text-success');
    document.getElementById("buttonMailSender2").classList.add('text-danger');
    $('#buttonMailSender2').attr("disabled", true);
    // document.getElementById("buttonMailSender3").classList.remove('text-success');
    // document.getElementById("buttonMailSender3").classList.add('text-danger');
    // $('#buttonMailSender3').attr("disabled", true);

     this.enableButtonParticiant(true);

     $( "button:disabled" ).attr("title", "Необходимо сохранить изменения");

     
    this.updateNeedAdjustmentState();
    this.isAucNeedAdjustment();
  }

  updateNeedAdjustmentState(){
    this.isContainCd = false; 
     this.isContainFm = false;  
     this.rejected = false;

     if(this.bus.currentAuction.drugs){
        for (let index = 0; index < this.bus.currentAuction.drugs.length; index++) {
          const element = this.bus.currentAuction.drugs[index];
          if(element.aucDetailAgreementStatus == null || element.aucDetailAgreementStatus == "") return
          const st = element.aucDetailAgreementStatus.toLowerCase();
          
          if(st == "согласование с кд"){
            this.isContainCd = true;
            }  

            if(st == "согласование с фм"){
              this.isContainFm = true;
            }  

          if(st == "отклонено"){
            this.rejected = true;
            }  
      }
    }
  }


  getSelectGood(value, row) {
    const currentSubGood = row.subDrugs[value.selectedIndex];
    this.changeDetail();

    if (currentSubGood !== undefined){
      this.mapSelectGood(row, currentSubGood);

      this.updateDrugs(null, currentSubGood.numberOfRow + currentSubGood.soloName);
    }
  }

  isLoadind: boolean = false;

  // Проверка статуса строки аукциона
  checkState(row, timeout, event) {
    if (timeout && (( 48 <= event.keyCode &&  event.keyCode <= 57) 
    || ( 96 <= event.keyCode &&  event.keyCode <= 105) 
    ||  110 == event.keyCode 
    || event.keyCode == 191 
    || event.keyCode == 188 
    || event.keyCode == 8 
    || event.keyCode == 46 
    || event.keyCode == 16 
    || event.keyCode == 17 
    || event.keyCode == 18 
    || event.keyCode == 190)) {
      return
    } else {
      this.isLoadind = false;
      this.updateDrugsAfterChangeСp(row.numberOfRow + row.soloName);
      this.changeDetail();
    }

  }

  mapSelectGood(row, currentSubGood){

    row.soloCode = currentSubGood.code;
    row.amountSolo = currentSubGood.amountSolo;
    row.startMaxPrice = currentSubGood.startMaxPrice;
    row.standartSoloPrice = currentSubGood.standartSoloPrice;
    row.minSoloPrice = currentSubGood.minSoloPrice;
    row.sumNmc = currentSubGood.sumNmc;
    row.sumPl = currentSubGood.sumPl;
    row.recommendedPriceType = "";
    row.recommendedPrice = 0;
    row.commertialPrice = 0;
    row.commertialPrice2 = 0;
    row.commertialPrice3 = 0;
    row.goodDetails = currentSubGood.goodDetails;
    row.specialPrice = currentSubGood.specialPrice;
    row.actualPosition = currentSubGood.actualPosition;
    row.rowColor = currentSubGood.rowColor;
    row.isIASDataError = currentSubGood.isIASDataError;
    row.aucDetailAgreementStatus = "Отсутствует";
  }

  getSelectWin(row) {
    this.changeDetail();
    row.manufacturer = "ООО Гротекс";

  }


  ngAfterViewInit(): void {
     $('#tableAuction').dataTable();
    $('[data-toggle="tooltip"]').tooltip();
   
  }

  public isContainSpecialPrice(price: string): boolean {
    if(price == "888888"){
      return true;
    }else{
    }
    return false;
 }

 public textContainSpecialPrice(price): string {
   switch (price) {
     case 222222:
       return "Эксклюзив"
     case 444444:
       return "Снята с производства"
     case 555555:
       return "Временная дефектура"
     case 777777:
       return "Розничная позиция"
     case 888888:
       return "Блэк-лист"

     default:
       return "false"
   }
}

// Проверка необходимости согласования в строке аукциона.
isRowNeedAdjustment(rowData) {

  if(rowData.aucDetailAgreementStatus == null || rowData.aucDetailAgreementStatus == "") return false;

  const st = rowData.aucDetailAgreementStatus.toLowerCase();

  if(this.token.isFM() && (st == "согласование с фм")){
    return true; 
  } else if(this.token.isCD() && (st == "согласование с кд" || st =="согласование с фм")){
    return true;
  }

  return false;

}

hideOutOfProduction(dt, type){
  let hideBtn = $('#hideOutOfProduction')
  let showBtn = $('#showOutOfProduction')

  if(type == 'hide'){
    showBtn.removeClass('btn-primary')
    showBtn.addClass('btn-secondary')
    hideBtn.removeClass('btn-secondary')
    hideBtn.addClass('btn-primary')
    dt.filter('false', 'isOutOfProduction', 'equals') 
  } else {    
    hideBtn.removeClass('btn-primary')
    hideBtn.addClass('btn-secondary')
    showBtn.removeClass('btn-secondary')
    showBtn.addClass('btn-primary')
    dt.reset()
  }
}

// Проверка необходимости согласования в аукционе.
isAucNeedAdjustment(){

  this.updateNeedAdjustmentState();
 
  if(this.token.isCD()){
    // if(this.isContainCd){
    //   return true;
    // }
    return false;
  }

  if(this.bus.currentAuction.drugs){
    
    if(this.token.isFM() && this.isContainFm && !this.isContainCd ){
      return false;
    }
    if( this.token.isFM() && this.isContainCd){
      return true; 
    }  

    if(this.isContainFm ||  this.isContainCd){
      return true; 
    }  

  }
  return false; 
}


setAdjustment(isAdjustment, rowData){

  if(!rowData.aucDetailAgreementStatus) return false;

  if(isAdjustment){
    rowData.aucDetailAgreementStatus = "Согласовано"
  }else{
    rowData.aucDetailAgreementStatus = "Отклонено"
  }
  
  this.changeDetail();
  //this.onSave();

  // Todo убрать?
  this.isRowNeedAdjustment(rowData);




}


@ViewChild(ModalSendAdjustmentComponent)
ModalSendAdjustment: ModalSendAdjustmentComponent;

sendAdjustment(){
  this.ModalSendAdjustment.cleannField();
}

SendAdjustmentMail(key) {

  switch (key) {
    case "confirm":
      // Отправка писем на согласование
      if (this.bus.currentAuction.code != null) {
        this.http.get<Array<string>>(apiServer + "/SendMailToConfirm/" + this.bus.currentAuction.code)
          .subscribe(resp => {
          });
      }
      break;
    case "rejected":
      // Отправка писем отклнонено
      if (this.bus.currentAuction.code != null) {
        this.http.get<Array<string>>(apiServer + "/SendMailToRejected/" + this.bus.currentAuction.code)
          .subscribe(resp => {
          });
      }
      break;
    case "confirmed":
      // Отправка писем согласовано
      if (this.bus.currentAuction.code != null) {
        this.http.get<Array<string>>(apiServer + "/SendMailToConfirmed/" + this.bus.currentAuction.code)
          .subscribe(resp => {
          });
      }
      break;

    default:
      break;
  }

}
}


// WEBPACK FOOTER //
// ./src/app/modules/home/components/home-main-modal-detail/home-main-modal-detail.component.ts